(function () {
  'use strict';

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.from((root || document).querySelectorAll(selector));
  }

  function formatMoneyDisplay(value) {
    if (!value) return '';
    return String(value)
      .trim()
      .replace(/(\d)[.,]00(?!\d)/g, '$1');
  }

  function getAddToCartSubmitButton() {
    var productForm = qs('product-form');
    if (!productForm) return null;

    return (
      productForm.querySelector('[type="submit"][name="add"]:not(.custom-product-popup)') ||
      productForm.querySelector('.product-form-add-to-cart-btn-2:not(.custom-product-popup)') ||
      productForm.querySelector('.product-form-add-to-cart-btn-1:not(.custom-product-popup)')
    );
  }

  function getProductFormSellingPlanInput(form) {
    if (!form) return null;

    return (
      form.querySelector('[name="selling_plan"]') ||
      qs('input[name="selling_plan"][form="' + form.id + '"]') ||
      qs('.skio-plan-picker input[name="selling_plan"]')
    );
  }

  function syncSellingPlanToForm(form, skio, plan, frequencyIndex) {
    var sellingPlanInput = getProductFormSellingPlanInput(form);

    if (plan === 'one-time') {
      if (sellingPlanInput) {
        sellingPlanInput.value = '';
        sellingPlanInput.disabled = true;
        sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if (!skio.frequencySelect) return;

    var options = Array.from(skio.frequencySelect.options);
    var selectedOption = options[frequencyIndex] || options[skio.frequencySelect.selectedIndex];

    if (!selectedOption) return;

    if (skio.sellingPlanInput) {
      skio.sellingPlanInput.value = selectedOption.value;
      skio.sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (sellingPlanInput) {
      sellingPlanInput.disabled = false;
      sellingPlanInput.value = selectedOption.value;
      sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function submitProductFormViaFetch(form, submitButton) {
    var cart = qs('cart-notification') || qs('cart-drawer');
    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var spinner = submitButton.querySelector('.loading__spinner');

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
            },
          };

    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(submitButton);
      }
    }

    config.body = formData;

    return fetch(cartAddUrl, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Unable to add the selected product.');
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'pomade-subscription-picker',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else if (window.routes && window.routes.cart_url) {
          window.location = window.routes.cart_url;
        }

        return response;
      })
      .finally(function () {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
      });
  }

  function getSkioElements() {
    return {
      oneTimeInput:
        qs('.skio-group-input[skio-one-time]') ||
        qs('.skio-plan-picker .skio-group-container input[skio-one-time]'),
      subscriptionInput:
        qs('.skio-group-input:not([skio-one-time])') ||
        qs('.skio-plan-picker .skio-group-container:not([skio-one-time]) input'),
      frequencySelect: qs('.skio-group-container select.skio-frequency'),
      sellingPlanInput: qs('.skio-plan-picker input[name="selling_plan"]'),
      subscriptionPrice: qs('.skio-price span[skio-subscription-price]'),
      comparePrice: qs('.skio-price span[skio-compare-price], .skio-price s, .skio-price del'),
      addToCartBtn: getAddToCartSubmitButton(),
      productFormEl: qs('product-form form'),
      productInfo: qs('.product__info-wrapper'),
    };
  }

  function waitForSkio(callback, attempts) {
    var remaining = attempts || 40;
    var skio = getSkioElements();

    if (skio.frequencySelect && (skio.oneTimeInput || skio.subscriptionInput) && getAddToCartSubmitButton()) {
      callback(skio);
      return;
    }

    if (remaining <= 0) {
      callback(getSkioElements());
      return;
    }

    setTimeout(function () {
      waitForSkio(callback, remaining - 1);
    }, 200);
  }

  function addUpsellToCart(variantId) {
    var cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
          },
        ],
      }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to add the selected upsell product.');
      }
      return response.json();
    });
  }

  function initSection(section) {
    if (section.dataset.skioBound === 'true') return;
    section.dataset.skioBound = 'true';

    var subscribeCard = qs('[data-subscription-card]', section);
    var onetimeCard = qs('[data-onetime-card]', section);
    var frequencyButtons = qsa('[data-frequency-index]', section);
    var subscribeRadio = qs('[data-subscribe-radio]', section);
    var onetimeRadio = qs('[data-onetime-radio]', section);
    var ctaButton = qs('[data-subscription-cta]', section);
    var ctaLabel = qs('[data-cta-label]', section);
    var subscriptionPriceEl = qs('[data-subscription-price]', section);
    var comparePriceEl = qs('[data-compare-price]', section);
    var onetimePriceEl = qs('[data-onetime-price]', section);
    var defaultIndex = parseInt(section.dataset.defaultFrequency || '1', 10);

    var state = {
      plan: 'one-time',
      frequencyIndex: defaultIndex,
    };

    function setSelectedFrequency(index) {
      frequencyButtons.forEach(function (btn) {
        var btnIndex = parseInt(btn.dataset.frequencyIndex, 10);
        btn.classList.toggle('is-selected', btnIndex === index);
      });
      state.frequencyIndex = index;
    }

    function setPlanUI(plan) {
      state.plan = plan;
      var isSubscription = plan === 'subscription';

      if (subscribeCard) {
        subscribeCard.classList.toggle('is-active', isSubscription);
        subscribeCard.classList.toggle('is-expanded', isSubscription);
      }
      if (onetimeCard) onetimeCard.classList.toggle('is-active', !isSubscription);
      if (subscribeRadio) subscribeRadio.classList.toggle('is-selected', isSubscription);
      if (onetimeRadio) onetimeRadio.classList.toggle('is-selected', !isSubscription);

      updateCtaLabel();
    }

    function updatePrices(skio) {
      if (skio.subscriptionPrice && subscriptionPriceEl) {
        subscriptionPriceEl.textContent = formatMoneyDisplay(skio.subscriptionPrice.textContent.trim());
      }

      if (comparePriceEl) {
        var compareNode =
          skio.comparePrice ||
          qs('.skio-group-container--selected .skio-price s') ||
          qs('.skio-group-container .skio-price s');

        if (compareNode) {
          comparePriceEl.textContent = formatMoneyDisplay(compareNode.textContent.trim());
          comparePriceEl.hidden = false;
        } else if (section.dataset.comparePrice) {
          comparePriceEl.textContent = formatMoneyDisplay(section.dataset.comparePrice);
        }
      }

      var oneTimePriceNode = qs('.skio-plan-picker .skio-group-container[skio-one-time] .skio-price');

      if (!oneTimePriceNode && skio.oneTimeInput) {
        var oneTimeContainer = skio.oneTimeInput.closest('.skio-group-container');
        if (oneTimeContainer) {
          oneTimePriceNode = oneTimeContainer.querySelector('.skio-price');
        }
      }

      if (!oneTimePriceNode) {
        var oneTimeInputEl = qs('.skio-plan-picker .skio-group-container input[skio-one-time]');
        if (oneTimeInputEl) {
          var container = oneTimeInputEl.closest('.skio-group-container');
          if (container) oneTimePriceNode = container.querySelector('.skio-price');
        }
      }

      if (oneTimePriceNode && onetimePriceEl) {
        var priceText = oneTimePriceNode.textContent.replace(/\+.*/i, '').trim();
        onetimePriceEl.textContent = formatMoneyDisplay(priceText.split(/\s+/)[0] || priceText);
      } else if (section.dataset.onetimePrice && onetimePriceEl) {
        onetimePriceEl.textContent = formatMoneyDisplay(section.dataset.onetimePrice);
      }
    }

    function getFrequencyCtaLabel() {
      var selectedButton = frequencyButtons.find(function (button) {
        return parseInt(button.dataset.frequencyIndex, 10) === state.frequencyIndex;
      });

      if (selectedButton && selectedButton.dataset.frequencyCta) {
        return selectedButton.dataset.frequencyCta.trim();
      }

      var skio = getSkioElements();
      if (skio.frequencySelect && skio.frequencySelect.options[state.frequencyIndex]) {
        return skio.frequencySelect.options[state.frequencyIndex].textContent.trim();
      }

      return '';
    }

    function updateCtaLabel() {
      if (!ctaLabel) return;

      var skio = getSkioElements();
      var prefix = section.dataset.ctaPrefix || 'Subscribe ·';

      if (state.plan === 'one-time') {
        var oneTime = onetimePriceEl ? formatMoneyDisplay(onetimePriceEl.textContent.trim()) : '';
        ctaLabel.textContent = (section.dataset.onetimeCta || 'Buy now') + (oneTime ? ' · ' + oneTime : '');
        return;
      }

      var price = formatMoneyDisplay(
        skio.subscriptionPrice
          ? skio.subscriptionPrice.textContent.trim()
          : subscriptionPriceEl
            ? subscriptionPriceEl.textContent.trim()
            : ''
      );

      var frequencyText = getFrequencyCtaLabel();
      var suffix = section.dataset.ctaSuffix || '';

      if (frequencyText) {
        ctaLabel.textContent = prefix + ' ' + price + ' ' + frequencyText;
      } else if (suffix) {
        ctaLabel.textContent = prefix + ' ' + price + ' ' + suffix;
      } else {
        ctaLabel.textContent = prefix + ' ' + price;
      }
    }

    function clickSubscriptionPlan(skio) {
      if (skio.subscriptionInput) {
        skio.subscriptionInput.click();
      } else {
        var containers = qsa('.skio-plan-picker .skio-group-container');
        var subscriptionContainer = null;
        for (var c = 0; c < containers.length; c++) {
          if (!containers[c].querySelector('[skio-one-time]') && !containers[c].querySelector('input[skio-one-time]')) {
            subscriptionContainer = containers[c];
            break;
          }
        }
        if (subscriptionContainer) {
          var subInput = subscriptionContainer.querySelector('input');
          if (subInput) subInput.click();
        }
      }

      if (skio.productInfo) skio.productInfo.classList.add('skio-plan-selected');
      setPlanUI('subscription');
    }

    function clickOneTimePlan(skio) {
      var oneTimeInput =
        skio.oneTimeInput ||
        qs('.skio-plan-picker .skio-group-container input[skio-one-time]');

      if (!oneTimeInput) {
        var containers = qsa('.skio-plan-picker .skio-group-container');
        for (var i = 0; i < containers.length; i++) {
          var input = containers[i].querySelector('input');
          if (input && (input.hasAttribute('skio-one-time') || i === 0)) {
            oneTimeInput = input;
            break;
          }
        }
      }

      if (oneTimeInput) oneTimeInput.click();

      if (skio.productInfo) skio.productInfo.classList.remove('skio-plan-selected');
      setPlanUI('one-time');
    }

    function setFrequencyIndex(index, skio) {
      if (!skio.frequencySelect) return;

      clickSubscriptionPlan(skio);

      var options = Array.from(skio.frequencySelect.options);
      if (!options[index]) return;

      skio.frequencySelect.selectedIndex = index;
      skio.frequencySelect.value = options[index].value;
      skio.frequencySelect.dispatchEvent(new Event('change', { bubbles: true }));
      skio.frequencySelect.dispatchEvent(new Event('input', { bubbles: true }));

      if (skio.sellingPlanInput) {
        skio.sellingPlanInput.value = options[index].value;
        skio.sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      setSelectedFrequency(index);
      updatePrices(skio);
      updateCtaLabel();
    }

    function addMainProductToCart(skio) {
      if (state.plan === 'subscription') {
        setFrequencyIndex(state.frequencyIndex, skio);
      } else {
        clickOneTimePlan(skio);
      }

      var form = qs('product-form form');
      var submitButton = getAddToCartSubmitButton();

      syncSellingPlanToForm(form, skio, state.plan, state.frequencyIndex);

      if (form && submitButton) {
        return submitProductFormViaFetch(form, submitButton);
      }

      if (!form) {
        return Promise.reject(new Error('Product form not found.'));
      }

      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) {
        return Promise.reject(new Error('Product variant not found.'));
      }

      var item = {
        id: Number(variantInput.value),
        quantity: 1,
      };

      var sellingPlanInput = getProductFormSellingPlanInput(form);
      if (state.plan === 'subscription' && sellingPlanInput && sellingPlanInput.value) {
        item.selling_plan = Number(sellingPlanInput.value);
      }

      var cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

      return fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: [item] }),
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to add the selected product.');
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'pomade-subscription-picker',
            productVariantId: String(item.id),
          });
        }

        var cartDrawer = qs('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(submitButton || ctaButton);
        }

        return response.json();
      });
    }

    function handleCtaClick() {
      if (ctaButton.disabled) return;

      var upsellCheckbox = qs('[data-upsell-variant-id]', section);

      var runAddToCart = function () {
        return addMainProductToCart(getSkioElements()).catch(function (error) {
          console.error(error);
        });
      };

      if (!upsellCheckbox || !upsellCheckbox.checked) {
        runAddToCart();
        return;
      }

      ctaButton.disabled = true;
      addUpsellToCart(upsellCheckbox.dataset.upsellVariantId)
        .catch(function (error) {
          console.error(error);
        })
        .then(function () {
          ctaButton.disabled = false;
          runAddToCart();
        });
    }

    if (ctaButton) {
      ctaButton.addEventListener('click', handleCtaClick);
    }

    function bindEvents(skio) {
      if (subscribeCard) {
        subscribeCard.addEventListener('click', function (event) {
          if (event.target.closest('[data-frequency-index]')) return;
          clickSubscriptionPlan(skio);
        });
      }

      if (onetimeCard) {
        onetimeCard.addEventListener('click', function () {
          clickOneTimePlan(skio);
        });
      }

      frequencyButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.stopPropagation();
          var index = parseInt(button.dataset.frequencyIndex, 10);
          setFrequencyIndex(index, skio);
        });
      });

      if (skio.frequencySelect) {
        skio.frequencySelect.addEventListener('change', function () {
          setSelectedFrequency(skio.frequencySelect.selectedIndex);
          updateCtaLabel();
          updatePrices(skio);
        });
      }

      document.addEventListener('change', function (event) {
        if (!(event.target instanceof HTMLInputElement)) return;
        if (!event.target.closest('.skio-plan-picker')) return;

        if (event.target.matches('[skio-one-time], .skio-group-input[skio-one-time]')) {
          setPlanUI('one-time');
        } else if (event.target.closest('.skio-group-container')) {
          setPlanUI('subscription');
        }
      });
    }

    function initSkio(skio) {
      updatePrices(skio);
      bindEvents(skio);
      setSelectedFrequency(defaultIndex);
      clickOneTimePlan(skio);
    }

    waitForSkio(initSkio);
  }

  function initAll() {
    qsa('.pomade-subscription-picker').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.pomade-subscription-picker');
    if (section) initSection(section);
  });
})();
